import Vue from "vue";
import { listMyPaymentOrders } from "./payment";

let latestMyPaymentOrdersRequestId = 0;

export const myPaymentOrdersState = Vue.observable({
  loading: false,
  loaded: false,
  orders: [],
  pagination: {
    limit: 20,
    offset: 0,
    has_more: false,
    total: 0,
  },
});

export function clearMyPaymentOrders() {
  latestMyPaymentOrdersRequestId = 0;
  myPaymentOrdersState.loading = false;
  myPaymentOrdersState.loaded = false;
  myPaymentOrdersState.orders = [];
  myPaymentOrdersState.pagination = {
    limit: 20,
    offset: 0,
    has_more: false,
    total: 0,
  };
}

export async function refreshMyPaymentOrders(params = {}) {
  const requestId = ++latestMyPaymentOrdersRequestId;
  myPaymentOrdersState.loading = true;
  let payload = null;
  try {
    payload = await listMyPaymentOrders(params);
  } finally {
    if (requestId === latestMyPaymentOrdersRequestId) {
      myPaymentOrdersState.loading = false;
    }
  }
  if (requestId !== latestMyPaymentOrdersRequestId) {
    return payload && payload.orders ? payload.orders : null;
  }
  const orders = payload && payload.orders ? payload.orders : null;
  const items = orders && Array.isArray(orders.items) ? orders.items : [];
  myPaymentOrdersState.orders = items;
  myPaymentOrdersState.pagination = {
    limit: orders && orders.limit != null ? Number(orders.limit || 0) : Number(params.limit || 20),
    offset: orders && orders.offset != null ? Number(orders.offset || 0) : Number(params.offset || 0),
    has_more: !!(orders && orders.has_more),
    total: orders && orders.total != null ? Number(orders.total || 0) : items.length,
  };
  myPaymentOrdersState.loaded = true;
  return orders;
}
